<template>
  <div>
    <!--page-header></page-header-->
    <router-view class="overflow-y-auto" :style="scrollViewStyle"></router-view>
    <!-- 제목 -->
    <v-row class="title-wrap ">
      <v-col cols="12" class="icon-title word-type pb-0"
      ><icon-paid-holiday :width="24" :height="24" />나의 근태/휴가 관리</v-col
      >
    </v-row>

    <v-simple-table class="px-6 mt-6">
      <template v-slot:default>
        <thead>
        <tr>
          <th class="text-center">
            구분
          </th>
          <th class="text-center">
            이월일수
          </th>
          <th class="text-center">
            발생일수
          </th>
          <th class="text-center">
            사용일수
          </th>
          <th class="text-center">
            잔여일수
          </th>
        </tr>
        </thead>
        <tbody>
        <tr
            v-for="item in desserts"
            :key="item.name"
        >
          <td>{{ item.name }}</td>
          <td>{{ item.remainOverDayNum }}</td>
          <td>{{ item.occurDayNum}}</td>
          <td>{{ item.useDayNum }}</td>
          <td>{{ item.remainDayNum }}</td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>

    <v-row class="title-wrap d-flex flex-column mt-7">
      <v-col class="d-flex detail-title "
      >휴가신청내용
      </v-col>
      <v-col class="pa-0" >
        <v-list-item-group>
          <v-list-item
              class="detail-list"
          >
            <v-list-item-content class="detail-list-content">
              <v-list-item-title>휴가신청일</v-list-item-title>
              <v-list-item-subtitle>
                <span>2023.06.12</span>
                <span class="vline">|</span>
                <span>2023.06.12</span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
        <v-list-item-group>
          <v-list-item
              class="detail-list"
          >
            <v-list-item-content class="detail-list-content">
              <v-list-item-title>연차휴가(1년미만-오전반반일)
              </v-list-item-title>
              <v-list-item-subtitle>
                <span>2023.06.12</span>
                <span class="vline">|</span>
                <span>2023.06.12</span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-col>
    </v-row>
    <!--btn one 적용-->
    <v-bottom-navigation
        v-model="value"
        fixed
        scroll-threshold="500"
        height="96"
        style="margin-bottom: 61px"
        elevation="0"
    >
      <v-row class="ma-0 py-5 px-6 btn-fixed-wrapper">
        <v-col cols="12">
          <v-btn
              block
              elevation="0"
              class="btn-fixed btn-green"
              @click="$emit('goApplMenuList')"
          >
            <span class="white--text">휴가신청</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-bottom-navigation>
  </div>

</template>
<script>
import PageHeader from '@/components/common/PageHeader.vue';
import IconPaidHoliday from "@/assets/customIcon/IconPaidHoliday.vue";
import ApplMenuIcon from "@/components/application/form/ApplMenuIcon.vue";
import dayjs from "dayjs";

export default {
  computed: {
    scrollViewStyle() {
      return `max-height: ${
        window.innerHeight - this.$store.getters.HEIGHT_BOTTOM_NAV
      }px`;
    },

    props: {
      menuList: Array,
    },

  },
  data: () => ({

    desserts: [
      {
        name: '연차휴가',
        remainOverDayNum: 0,
        occurDayNum: 19,
        useDayNum: 8.875,
        remainDayNum: 10.125,
      },
      {
        name: '연차휴가(1년미만)',
        remainOverDayNum: 0,
        occurDayNum: 19,
        useDayNum: 8.875,
        remainDayNum: 10.125,
      },
      {
        name: '보상휴가',
        remainOverDayNum: 0,
        occurDayNum: 19,
        useDayNum: 8.875,
        remainDayNum: 10.125,
      },
      {
        name: '리프레시휴가',
        remainOverDayNum: 0,
        occurDayNum: 19,
        useDayNum: 8.875,
        remainDayNum: 10.125,
      },
      {
        name: '보상휴가',
        remainOverDayNum: 0,
        occurDayNum: 19,
        useDayNum: 8.875,
        remainDayNum: 10.125,
      },
      {
        name: '포상휴가',
        remainOverDayNum: 0,
        occurDayNum: 19,
        useDayNum: 8.875,
        remainDayNum: 10.125,
      },
    ],
    remainOverDayNum: 0, // 이월일수
    useDayNum: 0, // 사용일수
    occurDayNum: 0, // 발생일수
    remainDayNum: 0, // 잔여일수
  }),
  components: {
    ApplMenuIcon,
    PageHeader,
    IconPaidHoliday,
  },
};
</script>

<style>
.v-main__wrap { padding-bottom: 96px; }
.v-data-table__wrapper { border-top: 1px solid #111; border-bottom: 1px solid #ccc;}
.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  word-break: keep-all;
  padding: 0 4px;
  background-color: #f5f5f5;
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td:first-child {
  word-break: break-all;
  padding: 0 4px !important;
  text-align:left;
  width: 65px;
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  word-break: break-all;
  padding: 4px !important;
  text-align:center;
  line-height: 1.4;
}
.v-item-group.v-bottom-navigation { box-shadow: none; }
</style>